var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"nav-footer-wrap"},[_vm._v(" Copyright @2022 wytxer "),_c('a',{staticClass:"footer-link",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v(" 浙ICP备8888888号-8 ")])])
}]

export { render, staticRenderFns }